<template>
  <DialogDescription v-bind="props" :class="cn('text-sm', props.class)">
    <slot />
  </DialogDescription>
</template>

<script setup>
import { DialogDescription } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps({});
</script>
